export function SevenPointStar({ className = "", ...props }) {
  const points = [];
  const spikes = 7;
  const outer = 48;
  const inner = 40;
  for (let i = 0; i < spikes * 2; i++) {
    const r = i % 2 === 0 ? outer : inner;
    const a = (Math.PI / spikes) * i - Math.PI / 2;
    points.push(`${(50 + r * Math.cos(a)).toFixed(2)},${(50 + r * Math.sin(a)).toFixed(2)}`);
  }
  return (
    <svg viewBox="0 0 100 100" className={className} aria-hidden="true" {...props}>
      <polygon points={points.join(" ")} fill="currentColor" />
    </svg>
  );
}

export function JordanFlag({ className = "", ...props }) {
  return (
    <svg viewBox="0 0 90 45" className={className} role="img" aria-label="Flag of Jordan" {...props}>
      <rect width="90" height="15" fill="#16130F" />
      <rect y="15" width="90" height="15" fill="#FFFFFF" />
      <rect y="30" width="90" height="15" fill="#007A3D" />
      <polygon points="0,0 38,22.5 0,45" fill="#CE1126" />
      <polygon
        points="12,17 13.1,20.6 16.9,20.6 13.9,22.8 15,26.4 12,24.2 9,26.4 10.1,22.8 7.1,20.6 10.9,20.6"
        fill="#FFFFFF"
      />
    </svg>
  );
}

export function StarDivider({ className = "" }) {
  return (
    <div className={`flex items-center gap-4 ${className}`} aria-hidden="true">
      <span className="h-px flex-1 bg-jordan-ink/20" />
      <SevenPointStar className="h-4 w-4 text-jordan-red" />
      <span className="h-px flex-1 bg-jordan-ink/20" />
    </div>
  );
}
